import React, { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";

const PlanGrid = ({ onSave }) => {
    const [plan, setPlan] = useState({ name: "", description: "" });
    const [plans, setPlans] = useState([]);
    const [editingRowIndex, setEditingRowIndex] = useState(null);

    // Handle Plan Save

    const handleSave = () => {
        if (plan.name && plan.description) {
            if (editingRowIndex !== null) {
                // Update existing row
                const updatedPlans = [...plans];
                updatedPlans[editingRowIndex] = { ...plan }; // Update the selected row
                setPlans(updatedPlans);
                setEditingRowIndex(null); // Reset editing index
            } else {
                // Add new row
                setPlans([...plans, { ...plan }]);
            }
            setPlan({ name: "", description: "" }); // Reset form
            onSave(plan); // Call parent function
        }
    }
    const handleEdit = (params) => {
        const rowIndex = params.node.rowIndex;
        setPlan({ ...plans[rowIndex] }); // Load selected row data into input fields
        setEditingRowIndex(rowIndex); // Store index for editing
    };
    const handleDelete = (params) => {
        const rowIndex = params.node.rowIndex;
        const updatedPlans = plans.filter((_, index) => index !== rowIndex);
        setPlans(updatedPlans); // Remove row from state
        setEditingRowIndex(null); // Reset editing index if deleting an edited row
        setPlan({ name: "", description: "" }); // Clear input fields if deleting an active edit
    };
    // Columns for AG Grid
    const columns = [
        { headerName: "Name", field: "name", flex: 1 },
        { headerName: "Description", field: "description", flex: 2 },
        {
            headerName: "Actions",
            field: "actions",
            cellRenderer: (params) => (
                <div className="d-flex gap-2">
                    <button type="button" className="btn btn-sm btn-primary" onClick={() => handleEdit(params)}>Edit</button>
                    <button type="button" className="btn btn-sm btn-danger" onClick={() => handleDelete(params)}>Delete</button>
                </div>
            ),
            flex: 1,
        },
    ];

    return (
        <div className="ag-theme-alpine mt-3" style={{ height: '100%' }}>
            <div className="mt-3 p-3 border rounded bg-light">
                <h6 className="text-secondary">Plan Details</h6>
                <div className="row">
                    <div className="col-md-6">
                        <label className="fw-semibold fs-small ">Name</label>
                        <input type="text" className="w-full px-3 py-2 shadow-md border border-gray-300 rounded-md focus:outline-none" value={plan.name} onChange={(e) => setPlan({ ...plan, name: e.target.value })} />
                    </div>
                    <div className="col-md-6 mt-2">
                        <label className="fw-semibold">Description</label>
                        <input type="text" className="w-full px-3 py-2 shadow-md border border-gray-300 rounded-md focus:outline-none" value={plan.description} onChange={(e) => setPlan({ ...plan, description: e.target.value })} />
                    </div>

                </div>
                <button type="button" onClick={handleSave} className="saveButton mt-3">Save</button>
            </div>
            {plans && plans.length > 0 &&
                <div className="ag-theme-alpine mt-5" style={{ height: '300px' }}>
                    <AgGridReact rowData={plans} columnDefs={columns} pagination={true} />
                </div>
            }
        </div>
    );
};

export default PlanGrid;